import { render, staticRenderFns } from "./CustomerContractEdit.vue?vue&type=template&id=d60f95be"
import script from "./CustomerContractEdit.vue?vue&type=script&lang=js"
export * from "./CustomerContractEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports